import { IonContent, IonHeader, IonItem, IonList, IonPage, IonTitle, IonToolbar, useIonAlert } from '@ionic/react'
import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { fromEvent } from 'rxjs'
import Button from '../../components/Button'
import { COUNTRY } from '../../const/constants'
import AppContext from '../../context/AppContext'

const MiCuenta = () => {
  const [presentAlert] = useIonAlert()
  const history = useHistory()
  const { settings, user }: any = useContext(AppContext)
  const [network, setNetwork] = useState('Verificando...')

  const networkMonitor = () => {
    if (navigator.onLine) setNetwork('Conectado')

    fromEvent(window, 'offline').subscribe(() => {
      setNetwork('Desconectado')
    })
    fromEvent(window, 'online').subscribe(() => {
      setNetwork('Conectado')
    })
  }

  useEffect(() => {
    networkMonitor()
  }, [navigator])

  const handleSession = () => {
    presentAlert({
      message: `¿Estás seguro que deseás cerrar la sesión?`,
      cssClass: 'logout-alert',
      buttons: [
        {
          text: 'Cerrar sesión',
          role: 'confirm',
          cssClass: 'logout-alert-btn',
          handler: () => {
            history.push('/logout')
            settings.country === COUNTRY.PY ? localStorage.removeItem('user') : localStorage.removeItem('userWithIDP')
            localStorage.removeItem('settings')
            location.reload()
          }
        },
        {
          text: '',
          role: 'cancel',
          id: 'close-btn',
          cssClass: 'close-alert-btn'
        }
      ]
    })
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="main-title">Mi cuenta</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="account__title">
          <h3>Datos</h3>
        </div>
        <div>
          <IonList className="my-account">
            {settings.country === COUNTRY.PY && (
              <IonItem color="light">
                <p className="session-data">
                  <b>Comercio: </b> <span>{user.kioskName}</span>
                </p>
              </IonItem>
            )}
            <IonItem color="light">
              <p className="session-data">
                <b>Número de POS: </b> <span>{user.posNumber}</span>
              </p>
            </IonItem>
            <IonItem color="light">
              <p className="session-data">
                <b>Internet: </b> <span className={network.toLowerCase()}>{network}</span>
              </p>
            </IonItem>
          </IonList>
        </div>
        <div className="account__logout__container">
          <Button
            id="logout"
            className="link-button-lower account__logout__btn"
            label="Cerrar sesión"
            handleSubmit={handleSession}
          />
        </div>
      </IonContent>
    </IonPage>
  )
}

export default MiCuenta
